<div class="bulk-edit-wrapper">

    <bulk-edit-toolbar [logTag]="COMPONENT_LOG_TAG"
                       (exit)="exitClicked()"
                       [options]="bulkTemplates.bulkOptions"
                       [facet]="facet"
                       [inactiveFields]="inactiveFields"
                       #bulkEditToolbar>
    </bulk-edit-toolbar>

    <div class="bulk-edit-grid">
        <bulk-edit-table [options]="bulkTemplates.bulkOptions"
                         [facet]="facet"
                         [itemsToEdit]="matings"></bulk-edit-table>
    </div>
</div>
    
<mating-bulk-templates [matings]="matings"
                       [activeFields]="activeFields"
                       [requiredFields]="requiredFields" #bulkTemplates></mating-bulk-templates>
